import { gsap } from 'gsap';
import morphSVG from './../MorphSVGPlugin';

(function($){

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  var initializeBlock = function( $block ) {
    gsap.registerPlugin(morphSVG)

    let searchOpen = ''

    $('.program-open').on('click', function() {
      searchOpen = 'programs'
      commonOpen()
      $('#search-form').addClass('tw-pointer-events-auto').removeClass('tw-pointer-events-none').attr('action', 'https://webtrrac.glenviewparks.org/WEB/wbwsc/webtrac.wsc/search.html').attr('target', '_blank')
      $('#search-use').attr('xlink:href', '#program-search-svg')
      $('#term').attr('name', 'keyword')
      $('.search-title').addClass('tw-opacity-0').removeClass('tw-opacity-100')
      gsap.to('.search-bkg-svg', {morphSVG:'M945.5,248.5h0V.5h0Z', duration: .5, ease: "none" })
      gsap.to('#program-search-svg', {morphSVG:'M893.3,114.2h-840v54h840V114.2z', duration: .43, ease: "none" })
    })

    $('.search-open').on('click', function() {
      searchOpen = 'search'
      commonOpen()
      $('#search-form').addClass('tw-pointer-events-auto').removeClass('tw-pointer-events-none').attr('action', '/').attr('target', '_self')
      $('#search-use').attr('xlink:href', '#search-search-svg')
      $('#term').attr('name', 's')
      $('.program-title').addClass('tw-opacity-0').removeClass('tw-opacity-100')
      $('.search-title').addClass('tw-left-0 md:tw-ml-10 lg:tw-ml-14').removeClass('tw-left-1/2')
      gsap.to('.search-bkg-svg', {morphSVG:'M945.5,248.5H.5V.5h945Z', duration: .5, ease: "none" })
      gsap.to('#search-search-svg', {morphSVG:'M893.3,114.2h-840v54h840V114.2z', duration: .43, ease: "none" })
    })

    $('.search-close').on('click', function() {
      $('.search-close').addClass('tw-opacity-0').removeClass('tw-opacity-100')
      $('.search-arrows').addClass('tw-opacity-100 tw-pointer-events-auto').removeClass('tw-opacity-0 tw-pointer-events-none')
      $('.search-title, .program-title').addClass('tw-opacity-100').removeClass('tw-opacity-0')
      $('.search-title').addClass('tw-left-1/2 tw-ml-4').removeClass('tw-left-0 md:tw-ml-10 lg:tw-ml-14')
      $('#term').val('')
      $('#search-form').addClass('tw-pointer-events-none').removeClass('tw-pointer-events-auto')

      if (searchOpen == 'search') {
        gsap.to('.search-bkg-svg', {morphSVG:'M946,0H437.25c-34.6,103.29,82.6,160.22,73.12,249H946Z', duration: .5, ease: "none" })
        gsap.to('#search-search-svg', {morphSVG:'M455,114.24c10.52,18.36,22.77,36,33.14,54H893.26v-54Z', duration: .43, delay: .07, ease: "none" })
      }

      if (searchOpen == 'programs') {
        gsap.to('#program-search-svg', {morphSVG:'M455,114.24H53.26v54H488.11C477.74,150.26,465.49,132.6,455,114.24Z', duration: .43, delay: .07, ease: "none" })
        gsap.to('.search-bkg-svg', {morphSVG:'M946,0H437.25c-34.6,103.29,82.6,160.22,73.12,249H946Z', duration: .5, ease: "none" })
      }

      searchOpen = ''
    })

    function commonOpen() {
      $('#term').focus()
      $('.search-arrows').addClass('tw-opacity-0 tw-pointer-events-none').removeClass('tw-opacity-100 tw-pointer-events-auto')
      $('.search-container').addClass('tw-bg-teal-600').removeClass('tw-bg-teal-800')
      $('.search-close').addClass('tw-opacity-100').removeClass('tw-opacity-0')
    }
  }

  // Initialize each block on page load (front end).
  $(document).ready(function(){
    $('.home-hero').each(function(){
      initializeBlock( $(this) );
    });
  });

  // Initialize dynamic block preview (editor).
  if( window.acf ) {
      window.acf.addAction( 'render_block_preview/type=simple-page-hero-section', initializeBlock );
  }

})(jQuery);
